<template>
    <section>
        <!-- Void Button -->
        <ClButton
            icon
            title="Void a Mail Item Transaction"
            aria-label="cancel"
            @click.stop.prevent="showModal = true"
        >
            <v-icon>mdi-cancel</v-icon>
        </ClButton>
        <!-- Void Modal -->
        <ClModal
            v-model="showModal"
            persistent
            width="400px"
            @keydown.esc="cancel()"
        >
            <v-card>
                <v-card-title class="modal-void-title">
                    <v-spacer />
                    Void Mail Item Transaction
                    <v-spacer />
                    <ClButton
                        icon
                        color="white"
                        title="Close Void Modal"
                        aria-label="close"
                        @click="showModal = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </ClButton>
                </v-card-title>
                <v-card-text class="modal-void-text">
                    <p>Select a reason to Void this Mail Item Transaction</p>
                    <v-radio-group
                        v-model="selectedReason"
                        column
                    >
                        <v-radio
                            v-for="( reason, index ) in voidReasonList"
                            :key="index"
                            :label="reason.label"
                            :value="reason.label"
                        />
                    </v-radio-group>
                    <ClInput
                        v-if="selectedReason === 'Other'"
                        v-model="otherReasonTextArea"
                        type="text"
                        label="Other Reason"
                        autofocus
                        primaryActionText="Void Transaction"
                    />
                </v-card-text>
                <v-card-actions>
                    <ClButton
                        buttonText="Cancel"
                        :rounded="false"
                        type="tertiary"
                        color="black"
                        @click="closeModal"
                    />
                    <v-spacer/>
                    <ClButton
                        buttonText="Void Transaction"
                        :rounded="false"
                        :disabled="!selectedReason"
                        :loading="inFlight"
                        @click="voidMailItemTransaction"
                    />
                </v-card-actions>
            </v-card>
        </ClModal>
    </section>
</template>

<script>
// Vuex
import { mapState, mapGetters } from 'vuex';

// Api
import LogisticsApi from '@/api/LogisticsApi';

export default {
    name: 'ButtonModalVoidTransaction',
    props: {
        mailItemId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            showModal: false,
            selectedReason: '',
            otherReasonTextArea: '',
            voidReasonList: [
                {
                    id: 'mistake',
                    label: 'Created By Mistake',
                },
                {
                    id: 'late',
                    label: 'Would Not Arrive on Time',
                },
                {
                    id: 'shipping',
                    label: 'Need to Change Shipping Address',
                },
                {
                    id: 'delivery',
                    label: 'Need to Change Delivery Method',
                },
                {
                    id: 'notPickedUp',
                    label: 'Not Picked Up',
                },
                {
                    id: 'other',
                    label: 'Other',
                },
            ],
            inFlight: false,
        };
    },
    computed: {
        ...mapGetters( {
            websiteId: 'Website/id',
        } ),
        ...mapState( {
            jwtToken: ( state ) => state.User.jwtToken,
            userAccountId: ( state ) => state.User.accountId,
        } ),
        selectedReasonIsOther() {
            return this.selectedReason === 'Other';
        },
    },
    methods: {
        closeModal() {
            this.showModal = false;
            this.selectedReason = '';
            this.otherReasonTextArea = '';
        },
        async voidMailItemTransaction() {
            this.inFlight = true;
            try {
                await LogisticsApi.voidMailItem( {
                    jwtToken: this.jwtToken,
                    websiteId: this.websiteId,
                    userAccountId: this.userAccountId,
                    mailItemId: this.mailItemId,
                    reason: this.selectedReasonIsOther
                        ? this.otherReasonTextArea
                        : this.selectedReason,
                } );
                this.$store.dispatch( 'snackbar', {
                    message: 'Mail Item Transaction Voided',
                    type: 'success',
                    duration: 5000,
                } );
                this.$emit( 'voidItemSuccess', this.mailItemId );
            } catch ( error ) {
                console.error( 'Error in voidMailItemTransaction: ', error );
                this.$store.dispatch( 'snackbar', {
                    message: error?.response?.data?.message,
                    type: 'error',
                    duration: -1,
                } );
                this.$emit( 'voidItemFailure' );
            } finally {
                this.inFlight = false;
                this.closeModal();
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.modal-void-title {
    color: $colors-white;
    background-color: $colors-primary;

    &__close {
        color: $colors-white;
    }
}

.modal-void-text {
    margin-top: 1rem;
}
</style>
